import { Workflow } from 'modules/workflows/types';
import { OpenNewWindow16 } from 'ui/icons';
import { Subtitle2 } from 'ui/theme';
import { WorkflowLiveStatusBadge } from 'modules/workflows/components/HeaderBar/WorkflowTitle';
import {
  linkedWorkflowsLabel,
  LINKED_WORKFLOWS_CONTENT_TEST_ID,
  LINKED_WORKFLOWS_LABEL_TEST_ID,
} from './constants';
import { StyledListForLinkedWorkflows } from './styled';

type LinkedWorkflowsListProps = {
  workflows: Pick<Workflow, 'id' | 'name' | 'workflowType' | 'enabled'>[];
};

export const LinkedWorkflowsList = ({ workflows }: LinkedWorkflowsListProps) => (
  <>
    <Subtitle2 data-test={LINKED_WORKFLOWS_LABEL_TEST_ID}>{linkedWorkflowsLabel}</Subtitle2>
    <StyledListForLinkedWorkflows data-test={LINKED_WORKFLOWS_CONTENT_TEST_ID}>
      {workflows.map(({ id, name, workflowType, ...rest }) => (
        <li key={id}>
          <a href={`/workflows/${id}/edit?workflowType=${workflowType}`} target="_blank">
            {name}
            <OpenNewWindow16 isColorInherited={true} />
          </a>
          <WorkflowLiveStatusBadge
            isWorkflowEnabled={!!rest?.enabled}
            workflowType={workflowType}
          />
        </li>
      ))}
    </StyledListForLinkedWorkflows>
  </>
);
